<template>
  <q-page padding>
    <PageHeader
      title="Upload de Arquivos"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-md bg-accent"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="unidade" label="Regras por Unidade" />
      <q-tab name="centro" label="Regras por Centro de Custo" />
      <q-tab name="funcao" label="Regras por Função" />
      <q-tab name="individual" label="Regras Individuais" />
    </q-tabs>

    <q-tab-panels v-model="tab" animated>
      <!-- ===== REGRAS POR UNIDADE ===== -->
      <q-tab-panel name="unidade">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Regras por Unidade
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide = !activeSlide"
            />
          </p>
        </div>
        <infot-upload
          :link="'https://multpex-docs.s3.us-east-1.amazonaws.com/templates/upload-regras/vendorxprodutos_r2.xlsx'"
          :activeSlide="activeSlide"
          :infos="infos"
          :showUnidade="false"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">Enviar planilha de regras por unidade</h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file1, 'drag-over': isDragOver1 }"
              @dragover.prevent="isDragOver1 = true"
              @dragleave.prevent="isDragOver1 = false"
              @drop.prevent="onDrop(1, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file1">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file1.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file1 ? 'positive' : 'primary'"
                      :icon="file1 ? 'check_circle' : 'folder_open'"
                      :label="
                        file1 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput1.click()"
                    />
                    <input
                      ref="fileInput1"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(1, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file1">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file1.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file1.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file1"
                @click="enviar(1, 'regra_por_vendor')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== REGRAS POR CENTRO DE CUSTO ===== -->
      <q-tab-panel name="centro">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Regras por Centro de Custo
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide3 = !activeSlide3"
            />
          </p>
        </div>
        <infot-upload
          :link="'https://multpex-docs.s3.us-east-1.amazonaws.com/templates/upload-regras/centroXprodutos_r2.xlsx'"
          :activeSlide="activeSlide3"
          :showUnidade="false"
          :infos="infos"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha de regras por centro de custo
            </h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file3, 'drag-over': isDragOver3 }"
              @dragover.prevent="isDragOver3 = true"
              @dragleave.prevent="isDragOver3 = false"
              @drop.prevent="onDrop(3, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file3">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file3.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file3 ? 'positive' : 'primary'"
                      :icon="file3 ? 'check_circle' : 'folder_open'"
                      :label="
                        file3 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput3.click()"
                    />
                    <input
                      ref="fileInput3"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(3, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file3">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file3.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file3.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file3"
                @click="enviar(3, 'regra_centro_custo')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== REGRAS POR FUNÇÃO ===== -->
      <q-tab-panel name="funcao">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Regras por Função
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide2 = !activeSlide2"
            />
          </p>
        </div>
        <infot-upload
          :link="'https://multpex-docs.s3.us-east-1.amazonaws.com/templates/upload-regras/funcaoXprodutos_r2.xlsx'"
          :showUnidade="false"
          :activeSlide="activeSlide2"
          :infos="infos"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha de regras por função / GHE
            </h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file2, 'drag-over': isDragOver2 }"
              @dragover.prevent="isDragOver2 = true"
              @dragleave.prevent="isDragOver2 = false"
              @drop.prevent="onDrop(2, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file2">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file2.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file2 ? 'positive' : 'primary'"
                      :icon="file2 ? 'check_circle' : 'folder_open'"
                      :label="
                        file2 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput2.click()"
                    />
                    <input
                      ref="fileInput2"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(2, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file2">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file2.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file2.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file2"
                @click="enviar(2, 'regra_por_funcao')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== REGRAS INDIVIDUAIS ===== -->
      <q-tab-panel name="individual">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Regras Individuais
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide4 = !activeSlide4"
            />
          </p>
        </div>
        <infot-upload
          :infos="infos"
          :link="'https://multpex-docs.s3.us-east-1.amazonaws.com/templates/upload-regras/individualxprodutos_r2.xlsx'"
          :activeSlide="activeSlide4"
          :showUnidade="false"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">Enviar planilha de regras individuais</h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file4, 'drag-over': isDragOver4 }"
              @dragover.prevent="isDragOver4 = true"
              @dragleave.prevent="isDragOver4 = false"
              @drop.prevent="onDrop(4, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file4">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file4.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file4 ? 'positive' : 'primary'"
                      :icon="file4 ? 'check_circle' : 'folder_open'"
                      :label="
                        file4 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput4.click()"
                    />
                    <input
                      ref="fileInput4"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(4, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file4">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file4.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file4.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file4"
                @click="enviar(4, 'regra_individual')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import InfotUpload from "../../compras/components/InfotUpload.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../../components/PageHeader.vue";

export default {
  components: { InfotUpload, ListaUnidadesSelect, PageHeader },
  setup() {
    const store = useStore();
    const $q = useQuasar();

    const activeSlide = ref(false);
    const activeSlide2 = ref(false);
    const activeSlide3 = ref(false);
    const activeSlide4 = ref(false);

    const file1 = ref(null);
    const file2 = ref(null);
    const file3 = ref(null);
    const file4 = ref(null);

    const fileInput1 = ref(null);
    const fileInput2 = ref(null);
    const fileInput3 = ref(null);
    const fileInput4 = ref(null);

    const isDragOver1 = ref(false);
    const isDragOver2 = ref(false);
    const isDragOver3 = ref(false);
    const isDragOver4 = ref(false);

    const files = { 1: file1, 2: file2, 3: file3, 4: file4 };

    const formatFileSize = (bytes) => {
      if (!bytes) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };

    const onFileSelected = (tab, e) => {
      if (e.target.files[0]) files[tab].value = e.target.files[0];
    };

    const onDrop = (tab, e) => {
      const dragRefs = {
        1: isDragOver1,
        2: isDragOver2,
        3: isDragOver3,
        4: isDragOver4,
      };
      dragRefs[tab].value = false;
      const f = e.dataTransfer.files[0];
      if (f && f.name.endsWith(".xlsx")) {
        files[tab].value = f;
      } else {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
      }
    };

    const enviar = async (tab, mapeamento) => {
      const fileRef = files[tab];
      if (!fileRef.value || !fileRef.value.name.endsWith(".xlsx")) {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
        return;
      }

      $q.loading.show({ message: "Enviando planilha..." });

      try {
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileRef.value);
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(reader.error);
        });

        await store.dispatch("grupoProdutos/uploads", {
          planilha: result,
          mapeamento,
          unidade: store.state.org.unidadeData.id,
        });

        $q.loading.hide();
        $q.notify({
          message: "Planilha enviada com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });

        fileRef.value = null;
      } catch (error) {
        $q.loading.hide();
        const mensagem =
          error?.response?.data?.message ||
          error?.message ||
          "Erro ao enviar o template";
        $q.notify({
          message: mensagem,
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    const infos = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      { name: "TODOS OS CAMPOS SÃO OBRIGATÓRIOS", icon: "delete" },
      {
        name: "O termo digitado no campo deve ser IDÊNTICO aos códigos dos centros de custo criados no sistema. Caso não encontre referência no sistema, a linha será ignorada.",
        icon: "view_column",
      },
      {
        name: "O termo referente a grupo de produto, digitado na coluna grupo_de_produto, deve ser IDÊNTICO ao criado no sistema, se o nome digitado não for encontrado, a importação irá ignorar a linha.",
        icon: "do_not_disturb",
      },
      {
        name: "Prazo mínimo e prazo máximo são fornecidos em DIAS, digite somente números. Não é aceito prazo 0",
        icon: "event",
      },
      {
        name: "A coluna quantidade deve ser preenchida com a quantidade esperada de uso no período definido. Este campo não pode ser 0.",
        icon: "event",
      },
      {
        name: "Tipo de controle é como você deseja monitorar as trocas dos usuários, sendo elas:",
        icon: "event",
      },
      { name: "Nenhum, Ambos, Farol, E-mail", icon: "event" },
    ]);

    return {
      activeSlide,
      activeSlide2,
      activeSlide3,
      activeSlide4,
      file1,
      file2,
      file3,
      file4,
      fileInput1,
      fileInput2,
      fileInput3,
      fileInput4,
      isDragOver1,
      isDragOver2,
      isDragOver3,
      isDragOver4,
      formatFileSize,
      onFileSelected,
      onDrop,
      enviar,
      infos,
      tab: ref("unidade"),
    };
  },
};
</script>

<style scoped>
.upload-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  padding: 24px;
  margin: 16px 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.upload-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

.header-icon {
  color: #1976d2;
}

.upload-title {
  margin: 0;
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.1rem;
}

.upload-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-area {
  background: white;
  border: 2px dashed #e0e4e7;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.upload-area:hover {
  border-color: #1976d2;
  background: #f8fafe;
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(25, 118, 210, 0.1);
}

.upload-area.file-selected {
  border-color: #4caf50;
  background: #f1f8e9;
}

.upload-area.drag-over {
  border-color: #1976d2;
  background: #e3f2fd;
  transform: scale(1.02);
}

.upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.upload-icon-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.upload-icon {
  color: white;
}

.upload-text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.upload-main-text {
  margin: 0;
  color: #546e7a;
  font-size: 1rem;
  font-weight: 500;
}

.upload-main-text.selected {
  color: #2e7d32;
  font-weight: 600;
}

.upload-button {
  cursor: pointer;
}

.upload-btn {
  min-width: 180px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.file-info {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e4e7;
}

.file-details {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.upload-actions {
  display: flex;
  justify-content: center;
}

.send-button {
  min-width: 160px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.send-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
</style>
